import { registry as baseRegistry } from './registry.js';
import { config } from './config.js';
import { showMessage, hideMessage } from './notify.js';
import { get_ajax, aj } from './ajax.js';
import { ggetPosition, openWin, closeWin, m_over, m_down, m_out } from './dom.js';

// Transition bridge: legacy callers (onclick, functions.js) can still reach the core helpers globally
Object.assign(window, { showMessage, hideMessage, get_ajax, aj, ggetPosition, openWin, closeWin, m_over, m_down, m_out });

// Show flash messages from fpx-config (runs deferred → showMessage is available)
if (Array.isArray(config.flash)) {
  config.flash.forEach(f => showMessage(f.type, f.text, f.reload ?? false, f.class ?? ''));
}

// Registry: base modules (shared, home/js/dist) + customer modules registered at runtime
// from the per-portal main.js. Same name in main.js overrides the base module.
const registry = { ...baseRegistry };
window.fpxRegisterModule = (name, loader) => { registry[name] = loader; };

async function runModules() {
  const wanted = new Map();                     // name → [elements]
  document.querySelectorAll('[data-module]').forEach(el => {
    const name = el.dataset.module;
    if (!wanted.has(name)) wanted.set(name, []);
    wanted.get(name).push(el);
  });

  for (const [name, elements] of wanted) {
    const load = registry[name];
    if (!load) { console.warn(`[fpx] unknown data-module: ${name}`); continue; }
    try {
      const mod = await load();
      if (typeof mod.init === 'function') mod.init(elements);
    } catch (e) {
      console.error(`[fpx] module "${name}" failed`, e);
    }
  }
}

// Scan only after DOMContentLoaded: by then the (later-loading) main.js
// has registered its customer modules via window.fpxRegisterModule. Module scripts are
// deferred and always run before DOMContentLoaded.
document.addEventListener('DOMContentLoaded', runModules, { once: true });
